export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6395.85a25316.jpg";